import { createApi } from '@reduxjs/toolkit/query/react'
import { HOME_EDUCATION_CLIENT_LIST, HOME_EDUCATION_CLIENT_DETAIL, HOME_EDUCATION_CLIENT_UPDATE, FAVOURITE_HOME_CLIENT } from "config/apiPaths"
import { RTK_CACHE_EXPIRATION } from "config/constants"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const homeEducationApi = createApi({
    reducerPath: 'homeEducationApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client/home_education",
    }),
    tagTypes: ["HomeEducationList", "HomeEducationDetails"],
    keepUnusedDataFor: RTK_CACHE_EXPIRATION,
    endpoints: (builder) => ({

        // get home education list
        getHomeEducationList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, grade = "", divison = [], sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: HOME_EDUCATION_CLIENT_LIST,
                    data: { search, status: status?.value || "", grade: grade?.value || "", page, limit, divison, sort, }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["HomeEducationList"]
        }),

        // home education client details
        getHomeEducationDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${HOME_EDUCATION_CLIENT_DETAIL}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["HomeEducationDetails"]
        }),

        // update client
        updateHomeEducationClient: builder.mutation({
            query: (data) => ({
                method: "PUT",
                url: `${HOME_EDUCATION_CLIENT_UPDATE}/${data.id}`,
                data: data.payload
            }),
            invalidatesTags: ["HomeEducationList", "HomeEducationDetails"]
        }),

        favouriteHomeClient: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_HOME_CLIENT}/${id}`,
                data
            }),
            invalidatesTags: ["HomeEducationList", "HomeEducationDetails"]
        }),
    }),
})

export const {
    useGetHomeEducationListQuery,
    useGetHomeEducationDetailsQuery,
    useLazyGetHomeEducationListQuery,
    useUpdateHomeEducationClientMutation,
    useFavouriteHomeClientMutation
} = homeEducationApi;